import { List, Map } from 'immutable';
import { call, put, select } from 'redux-saga/effects';
import UAParser from 'ua-parser-js';

import * as PlaybackActions from '../../../actions/Playback';
import { getInDomain } from '../../../domains/externalUtils';
import { putAndWait } from '../../../sagas/TaskManager';

import * as Helpers from './helpers';

export function* playRewardsAd(action) {
  const { rewardThresholdSeconds, rewardProperties, offerName, ...params } = action.data;
  const isPlaying = yield select(getInDomain('playback.utils.isAudioPlaying', false));
  const eventChannelHandlers = {};
  const videoSettingsForOffer = yield call(
    getInDomain('rewards.utils.getRewardVideoSettingsByOfferName'),
    offerName,
  );
  const coachmarkData = yield select(getInDomain('rewards.utils.getOpenCoachmarkData', new Map()));

  yield call(Helpers.closeRewardsCoachmark);

  const data = {
    ...params,
    ...rewardProperties,
    ...videoSettingsForOffer,
    offerName,
    trackingEvents: coachmarkData.get('trackingEvents', new List()).toJS(),
    companion: coachmarkData.get('companion'),
    rewardThresholdSeconds,
    duration: coachmarkData.get('duration'),
    width: coachmarkData.get('width'),
    height: coachmarkData.get('height'),
    eventChannelHandlers,
  };

  // will block until playback has completed and return the status
  const { completed, currentTime, errored, canResumeAudio } = yield call(
    getInDomain('videoAds.utils.playFlexVideo'),
    data,
  );

  if (errored || completed || !rewardThresholdSeconds || currentTime >= rewardThresholdSeconds) {
    const deviceId = yield select(getInDomain('application.utils.getDeviceId', ''));
    const os = new UAParser().getOS().name;
    const clientTimestamp = Date.now();
    const playableSourceId = yield select(
      getInDomain('rewards.utils.getPlayableSourceId'),
      offerName,
    );
    const svxParams = {
      offerName,
      playableSourceId,
      os,
      clientTimestamp,
      ...rewardProperties,
      deviceId,
    };
    const stationId = yield select(getInDomain('playback.utils.getCurrentStationId'));
    yield put(getInDomain('playback.actions.startValueExchange')(svxParams, stationId));
  } else if (isPlaying && canResumeAudio) {
    yield call(putAndWait, PlaybackActions.intentPlayTrack());
  }
}

export function* closeRewardsModal() {
  yield call(Helpers.closeRewardsCoachmark);
}
